module.exports = __webpack_public_path__ + "static/img/10.e4d47a7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/static/gameImg/online/10.jpg
// module id = obpj
// module chunks = 0